import Laboratory from './Laboratory';

export default {
  component: Laboratory,
  priority: 500,
  permissions: ['Dashboard'],
  name: 'Laboratory',
  icon: 'air-conditioner',
  drawer: true,
};
